import React, { ReactNode } from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';
import { MdClose } from 'react-icons/md';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
  children?: ReactNode;
}

const SimpleModal = ({ isOpen, children, onClose, className }: ModalProps) => {
  return (
    <ReactModal
      appElement={document.getElementById('root') || document.body}
      className={cn(className)}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          background: 'none',
          border: 'none',
          borderRadius: 'unset',
          padding: 0,
          maxWidth: 600,
        },
      }}
    >
      {onClose && (
        <button
          className="absolute top-1 right-1"
          onClick={onClose}
          aria-label="close"
        >
          <MdClose size={'2rem'} />
        </button>
      )}

      {children}
    </ReactModal>
  );
};

export default SimpleModal;
